export const enum Milliseconds {
  TEN_SECONDS = 10000,
}
